import { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

import { images } from "../../constants/";
import { menuData } from "../../utils";

import "./Navbar.scss";

const Navbar = ({activeIndex}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const variants = {
    open: { opacity: 1, x: 0 },
    closed: { opacity: 0, x: "100%" },
  };

  return (
    <header className="header">
      <div className="header__container">
        <div className="header__menu menu">
          <nav className="menu__body">
            <div className="menu__logo">
              <img src={images.logo} alt="mun-a logo" />
            </div>
            <ul className="menu__list">
              {menuData.map((item, index) => (
                <li className="menu__item" key={item}>
                  <a
                    href={`#${item}`}
                    className={`menu__link ${
                      activeIndex === index ? "active-link" : ""
                    }`}
                    // onClick={() => handleActiveLink(index)}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
            <motion.div
              className="mobile-menu"
              initial='closed'
              animate={isOpen ? "open" : "closed"}
              variants={variants}
              transition={{
                x: { type: "spring", stiffness: 70 },
                default: { duration: 0.5 },
              }}
            >
              <ul className="mobile-menu__list">
                {menuData.map((item, index) => (
                  <li className="mobile-menu__item" key={item}>
                    <a
                      href={`#${item}`}
                      className={`mobile-menu__link ${
                        activeIndex === index ? "active-link" : ""
                      }`}
                      onClick={handleClick}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          </nav>
          <button
            type="button"
            className="menu__icon icon-menu"
            onClick={handleClick}
          >
            {isOpen ? <HiX /> : <HiMenuAlt4 />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
